"use strict";

exports.__esModule = true;
exports.getThemeStyle = getThemeStyle;

var _color = _interopRequireDefault(require("color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getThemeStyle(theme) {
  if (!theme) {
    return {};
  }

  const primaryColor = theme.primaryColor;

  if (!primaryColor) {
    return {};
  }

  const backgroundColor = (0, _color.default)(primaryColor);
  let color;

  if (backgroundColor.isDark()) {
    color = "white";
  } else {
    color = "black";
  }

  return {
    backgroundColor: backgroundColor,
    color: color
  };
}